import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const AwardIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 22.7501C11.3998 22.7501 10.8098 22.6101 10.3298 22.3401L5.59977 19.6101C3.63977 18.2901 3.50977 18.0501 3.50977 15.9801V11.0201C3.50977 8.95006 3.63977 8.71006 5.55977 7.42006L10.3398 4.66006C11.2898 4.11006 12.7198 4.11006 13.6698 4.66006L18.3998 7.39006C20.3598 8.71006 20.4898 8.95006 20.4898 11.0201V15.9801C20.4898 18.0501 20.3598 18.2901 18.4398 19.5801L13.6598 22.3401C13.1898 22.6201 12.5898 22.7501 11.9998 22.7501ZM11.9998 5.75006C11.6598 5.75006 11.3198 5.82006 11.0798 5.96006L6.34977 8.69006C5.00977 9.60006 5.00977 9.60006 5.00977 11.0201V15.9801C5.00977 17.4001 5.00977 17.4001 6.39977 18.3401L11.0898 21.0401C11.5698 21.3201 12.4398 21.3201 12.9198 21.0401L17.6498 18.3101C18.9898 17.4001 18.9898 17.4001 18.9898 15.9801V11.0201C18.9898 9.60006 18.9898 9.60006 17.5998 8.66006L12.9098 5.96006C12.6798 5.82006 12.3398 5.75006 11.9998 5.75006Z"
        fill="currentColor"
      />
      <path
        d="M17.5 8.38C17.09 8.38 16.75 8.04 16.75 7.63V5C16.75 3.42 16.08 2.75 14.5 2.75H9.5C7.92 2.75 7.25 3.42 7.25 5V7.56C7.25 7.97 6.91 8.31 6.5 8.31C6.09 8.31 5.75 7.98 5.75 7.56V5C5.75 2.58 7.08 1.25 9.5 1.25H14.5C16.92 1.25 18.25 2.58 18.25 5V7.63C18.25 8.04 17.91 8.38 17.5 8.38Z"
        fill="currentColor"
      />
      <path
        d="M13.6302 17.6301C13.4202 17.6301 13.2002 17.5901 12.9802 17.5001L12.0002 17.1201L11.0202 17.5101C10.4902 17.7201 9.95024 17.6701 9.55024 17.3801C9.15024 17.0901 8.94024 16.5901 8.97024 16.0201L9.03024 14.9701L8.36024 14.1601C8.00024 13.7101 7.88024 13.1901 8.04024 12.7101C8.19024 12.2401 8.60024 11.8801 9.15024 11.7401L10.1702 11.4801L10.7402 10.5901C11.3502 9.63012 12.6602 9.63012 13.2702 10.5901L13.8402 11.4801L14.8602 11.7401C15.4102 11.8801 15.8202 12.2401 15.9702 12.7101C16.1202 13.1801 16.0002 13.7101 15.6402 14.1501L14.9702 14.9601L15.0302 16.0101C15.0602 16.5801 14.8502 17.0701 14.4502 17.3701C14.2102 17.5401 13.9302 17.6301 13.6302 17.6301ZM9.52024 13.2001L10.1902 14.0101C10.4202 14.2801 10.5502 14.7101 10.5302 15.0601L10.4702 16.1101L11.4502 15.7201C11.7802 15.5901 12.2202 15.5901 12.5502 15.7201L13.5302 16.1101L13.4702 15.0601C13.4502 14.7101 13.5802 14.2901 13.8102 14.0101L14.4802 13.2001L13.4602 12.9401C13.1202 12.8501 12.7602 12.5901 12.5702 12.3001L12.0102 11.4201L11.4402 12.3001C11.2502 12.6001 10.8902 12.8601 10.5502 12.9501L9.52024 13.2001Z"
        fill="currentColor"
      />
    </svg>
  );
};
const AwardIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={AwardIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default AwardIcon;
